import React, { FC } from 'react'
import { Tooltip } from 'react-tooltip'
import styled from 'styled-components'
import InformationIconSvg from '@tuhi/components/assets/images/informationIcon.svg'
import { ZIndex } from '../../constants'

export const TooltipContainer = styled.div`
    display: flex;
    align-items: center;

    svg {
        height: 28px;
        width: 28px;
    }

    .tooltip-container {
        max-width: 420px;
        padding: 16px 24px;
        opacity: 1;

        background-color: ${(p) => p.theme.colors.tertiary.tertiary50};
        border-radius: 8px;
        box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
        z-index: ${ZIndex.Tooltip};
    }
`

interface Props {
    id: string
    children: React.ReactNode
}

export const HelpTooltip: FC<Props> = ({ id, children }) => {
    return (
        <TooltipContainer id={id}>
            <InformationIconSvg />
            <Tooltip
                anchorSelect={`#${id}`}
                className="tooltip-container"
                place="right-start"
                render={() => children}
            />
        </TooltipContainer>
    )
}
